import { DynamicFormOptions, BaseEditField } from '../models/edit-fields';
import { UntypedFormGroup, UntypedFormControl, AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DynamicFormHelperService {
  createEditForm(options: DynamicFormOptions): UntypedFormGroup {
    let controls: { [key: string]: AbstractControl } = {};
    options.fields.forEach((field) => {
      Object.assign(controls, this.createFormControl(field, options));
    });

    return new UntypedFormGroup(controls);
  }

  private createFormControl(
    field: BaseEditField,
    options: DynamicFormOptions
  ): { [key: string]: AbstractControl } {
    const formControlOptions: { value: any; disabled: boolean } = {
      value: '',
      disabled: false,
    };

    if (!options.getFormUrl) {
      if (field.type === 'checkbox') {
        let defaultValue: boolean;
        try {
          defaultValue = JSON.parse(field.defaultValue);
        } catch {
          defaultValue = false;
        }
        formControlOptions.value = defaultValue;
      } else formControlOptions.value = field.defaultValue ?? '';
    }

    if (!options.saveFormUrl || !!field.readonly)
      formControlOptions.disabled = true;

    return {
      [field.id]: new UntypedFormControl(formControlOptions),
    };
  }
}
